<div class="questionnaire-preview-container">
  <!-- Preview Header -->
  <div class="preview-header">
    <div class="preview-header__left">
      <h2 class="preview-header__title">Preview</h2>
    </div>
    <div class="preview-header__center">
      <button
        class="view-mode-btn"
        [class.active]="viewMode === 'split'"
        (click)="setViewMode('split')"
        title="Split View"
      >
        @if(viewMode === 'split') {
        <i class="bi bi-pc-display"></i>
        <span>Split View</span>
        } @else {
        <i class="bi bi-pc-display"></i>
        }
      </button>
      <button
        class="view-mode-btn"
        [class.active]="viewMode === 'desktop'"
        (click)="setViewMode('desktop')"
        title="Desktop View"
      >
        @if(viewMode === 'desktop') {
        <i class="bi bi-display"></i>
        <span>Web View</span>
        } @else {
        <i class="bi bi-display"></i>
        }
      </button>
      <button
        class="view-mode-btn"
        [class.active]="viewMode === 'mobile'"
        (click)="setViewMode('mobile')"
        title="Mobile View"
      >
        @if(viewMode === 'mobile') {
        <i class="bi bi-phone"></i>
        <span>Mobile View</span>
        } @else {
        <i class="bi bi-phone"></i>
        }
      </button>
    </div>
    <div class="preview-header__right">
      <!-- <div class="page-selector">
        <span>Page {{ currentPage }}</span>
        <i class="fa-solid fa-chevron-down"></i>
      </div> -->
      <!-- <button class="refresh-btn" (click)="refreshPreview()" title="Refresh">
        @if(isLoading) {
        <app-spinner [size]="'small'" [variant]="'secondary'"></app-spinner>
        } @else {
        <i class="fa-solid fa-rotate"></i>
        }
      </button> -->
    </div>
  </div>

  <!-- Split View Container -->
  <div class="preview-content" [ngClass]="'view-mode-' + viewMode"
  >
    @switch(viewMode) { @case('split') {
    <app-split ></app-split>
    } @case('desktop') {
    <app-desktop
    
    ></app-desktop>
    } @case('mobile') {
    <app-mobile
     
    ></app-mobile>
    } }
  </div>
</div>

<!-- height: calc(100vh - 140px) !important; -->